// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2hjI0","rootSuccess":"CompleteLink_rootSuccess__3ZVlv","rootFailure":"CompleteLink_rootFailure__2O1X-","isDisabled":"CompleteLink_isDisabled__1-s7_"};